import { render, staticRenderFns } from "./SimpleView.vue?vue&type=template&id=34d29d7f&scoped=true"
import script from "./SimpleView.vue?vue&type=script&lang=js"
export * from "./SimpleView.vue?vue&type=script&lang=js"
import style0 from "./SimpleView.vue?vue&type=style&index=0&id=34d29d7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d29d7f",
  null
  
)

export default component.exports